import { render, staticRenderFns } from "./AdditionalInfoNew.vue?vue&type=template&id=35ddb1b2&scoped=true&"
import script from "./AdditionalInfoNew.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoNew.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfoNew.vue?vue&type=style&index=0&id=35ddb1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddb1b2",
  null
  
)

export default component.exports